import { useScreenSize } from '@/hooks';
import { Button, Table } from '@/shared/components';
import { TableProps } from '../components/Table/table';
import { styled } from '@mui/system';
import { useState } from 'react';
import { NAMESPACE, useLang } from '@/hooks/use-lang';

const StyledResponsiveTable = styled('div')`
  box-shadow: 0 2px 4px 0 rgba(34, 34, 34, 0.1);
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  height: fit-content;
  margin: 0.2rem;
  background-color: #ebf2fa;
  padding: 32px;
  color: #222222;
  display: flex;
  flex-direction: column;
`;

interface MobileProps<T> extends TableProps {
  item: T;
  index: number;
}

function ResponsiveTable<T>(props: TableProps<T>) {
  const screenSize = useScreenSize();

  return (
    <div>
      {(screenSize === 'xl' || screenSize === '2xl') && <Table<T> {...props} />}
      {(screenSize === 'lg' || screenSize === 'md' || screenSize === 'sm') &&
        props.dataSource?.map((item, index) => <MobileTable<T> {...props} item={item} index={index} key={index} />)}
    </div>
  );
}

function MobileTable<T>(props: MobileProps<T>) {
  const { item, index } = props;
  const [expanded, setExpanded] = useState(false);
  const { t } = useLang(NAMESPACE.common);

  const onClickExpanded = () => {
    setExpanded(!expanded);
  };
  return (
    <StyledResponsiveTable className="flex gap-y-2 md:mt-4 sm:mt-4 lg:mt-4">
      {props.columns?.map((column, columnIndex) => (
        <div className="grid grid-cols-2 sm:grid-cols-1" key={columnIndex}>
          <div className=" font-bold">{typeof column.header === 'function' ? column.header() : column.header}</div>
          <div>{column.cell ? column.cell(item, index) : item[column.accessorKey]}</div>
        </div>
      ))}
      {props.expandable?.rowExpandable(item) && (
        <Button
          className="mt-4"
          type={expanded ? 'primary' : 'outline'}
          onClick={onClickExpanded}
          endIconSize="8"
          endIconName={expanded ? 'caret-up' : 'caret-down'}
        >
          {t('expanded')}
        </Button>
      )}
      {expanded && props.expandable?.expandedRowRender(item, expanded)}
    </StyledResponsiveTable>
  );
}

export default ResponsiveTable;
